import { useIntl } from 'react-intl';

import { PageHeaderAction } from '@verantos-dev/shared-components';

import { useCohortListBreadCrumbs } from './useCohortListBreadCrumbs';
import { useCohortModalContext } from '../context/modalContext';

export const useCohortsListPageHeader = () => {
  const intl = useIntl();
  const {
    isCreateCohortModalOpen,
    isDeleteCohortModalOpen,
    isRenameCohortModalOpen,
    isExportCohortModalOpen,
    isCopyCohortModalOpen,
    openCreateCohortModal,
  } = useCohortModalContext();

  const onCreateCohortButtonClick = () => {
    openCreateCohortModal();
  };

  const actions: PageHeaderAction[] = [
    {
      id: 'createCohortButton',
      startIcon: 'add',
      label: intl.formatMessage({
        id: 'cohortsList.pageHeader.createCohortButton',
        defaultMessage: 'Create cohort',
      }),
      onClickHandler: onCreateCohortButtonClick,
    },
  ];

  const breadcrumbs = useCohortListBreadCrumbs();

  return {
    pageTitle: intl.formatMessage({
      id: 'cohortsList.pageHeader.title',
      defaultMessage: 'Cohorts',
    }),
    actions,
    breadcrumbs,
    isCreateCohortModalOpen,
    isDeleteCohortModalOpen,
    isRenameCohortModalOpen,
    isExportCohortModalOpen,
    isCopyCohortModalOpen,
  };
};
